import React, { useState, useCallback } from "react";

import { Snackbar, Alert } from "@mui/material";

const withErrorHandling = (Component) => {
  const Error = (props) => {
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const showError = useCallback((errorMsg) => {
      setError(errorMsg);
    }, []);

    const showSuccess = useCallback((message) => {
      setSuccess(message);
    }, []);

    const onCloseError = () => setError(null);
    const onCloseSuccess = () => setSuccess(null);

    return (
      <>
        <Component {...{ ...props, showError, showSuccess }} />
        <Snackbar
          open={!!error}
          onClose={onCloseError}
          autoHideDuration={6000}
        >
          <Alert
            onClose={onCloseError}
            severity="warning"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {error}
          </Alert>
        </Snackbar>
        <Snackbar
          open={!!success}
          onClose={onCloseSuccess}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={onCloseSuccess}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {success}
          </Alert>
        </Snackbar>
      </>
    );
  };

  return Error;
};

export default withErrorHandling;
